import {PagedData} from "@/services/models/shared/PagedData";
import {AxiosResponse} from "axios"
import {
    NewOracleAccountModuleRole,
    NewOracleModuleRole,
    OracleAccount,
    OracleAccountFilterOptions,
    OracleAccountListItem,
    OracleModule,
    OracleModuleOrganizationRoleListItem,
    OracleModuleRole,
    OracleOrganizationRoleFilterOptions,
    UpdateOracleAccountModuleRole
} from "@/services/models/Oracle";
import BimsHttpService from "@/services/BimsHttpService";


class OracleService {
    /**
     * @description Returns a paged list of organization roles.
     */
    getModuleOrganizationRoleList(filter: OracleOrganizationRoleFilterOptions): Promise<PagedData<OracleModuleOrganizationRoleListItem>> {
        return BimsHttpService.get(`/oracle/modules/OrganizationRoles`, {
            params: filter
        }).then((response: AxiosResponse<PagedData<OracleModuleOrganizationRoleListItem>>) => {
            return response.data as PagedData<OracleModuleOrganizationRoleListItem>;
        });
    }

    /**
     *  @description Retrieves all module organization roles
     */
    getAllModuleOrganizationRoles(): Promise<OracleModuleOrganizationRoleListItem[]> {
        const vm = this;
        return vm.getModuleOrganizationRoleList({
            pageSize: 1
        } as OracleOrganizationRoleFilterOptions)
            .then((response) => {
                return vm.getModuleOrganizationRoleList({
                    pageSize: response.totalCount,
                    page: 1
                } as OracleOrganizationRoleFilterOptions)
                    .then((responses) => {
                        return responses.data;
                    })
            })
    }

    /**
     *  @description Retrieves all module roles for the given module id
     */
    getModuleRoles(moduleRoleId: number): Promise<OracleModuleRole[]> {
        return BimsHttpService.get(`/oracle/modules/${moduleRoleId}/roles`,).then((response: AxiosResponse<any>) => {
            return response.data;
        });
    }

    /**
     *  @description Adds a new module role
     */
    addModuleRole(moduleRole: NewOracleModuleRole): Promise<any> {
        return BimsHttpService.post(`/oracle/modules/OrganizationRoles`,
            moduleRole
        );
    }

    /**
     * @description Returns a paged list of oracle accounts.
     */
    getOracleAccountList(filter: OracleAccountFilterOptions): Promise<PagedData<OracleAccountListItem>> {
        return BimsHttpService.get(`/oracle/accounts`, {
            params: filter
        }).then((response: AxiosResponse<PagedData<OracleAccountListItem>>) => {
            return response.data as PagedData<OracleAccountListItem>;
        });
    }

    /**
     * @description Returns the oracle account with the specified id
     */
    getOracleAccount(id: number): Promise<OracleAccount> {
        return BimsHttpService.get(`/oracle/accounts/${id}`).then((response: AxiosResponse<OracleAccount>) => {
            return response.data as OracleAccount;
        });
    }

    /**
     * @description Creates the oracle account module role
     */
    addAccountModuleRole(accountId: number, moduleRole: NewOracleAccountModuleRole): Promise<any> {
        return BimsHttpService.post(`/oracle/accounts/${accountId}/moduleRoles/`,
            moduleRole
        );
    }

    /**
     * @description Updates the oracle account module role
     */
    updateAccountModuleRole(accountId: number, moduleRole: UpdateOracleAccountModuleRole): Promise<any> {
        return BimsHttpService.put(`/oracle/accounts/${accountId}/moduleRoles/${moduleRole.moduleRoleId}`,
            moduleRole
            , {
                params: {
                    organizationRoleName: moduleRole.organizationRoleName,
                }
            });
    }

    /**
     * @description Deletes the oracle account module role
     */
    deleteAccountModuleRole(accountId: number, moduleRoleId: number, organizationRoleName: string): Promise<any> {
        return BimsHttpService.delete(`/oracle/accounts/${accountId}/moduleRoles/${moduleRoleId}`, {
            params: {
                organizationRoleName
            }
        });
    }

    /**
     * @description Retrieves all oracle modules
     */
    getAllModules(): Promise<OracleModule[]> {
        return BimsHttpService.get(`/oracle/modules`).then((response: AxiosResponse<OracleModule[]>) => {
            return response.data as OracleModule[];
        });
    }
}

export default new OracleService()
